module.exports = __webpack_public_path__ + "img/ic_people.e1a099de.svg";